import PropTypes from 'prop-types';
import { Show, TextField, useTranslate } from 'react-admin';
import { RightDrawer } from '@/components/global/drawers/RightDrawer.jsx';
import { DetailsSampleList } from '@/components/global/fields/DetailsSampleList.jsx';
import { ChangeHistory } from '@/components/global/history/ChangeHistory.jsx';

export const PromptShow = ({ handleClose, elementId }) => {
    const translate = useTranslate();

    return (
        <RightDrawer
            handleClose={handleClose}
            title={translate('common.details')}
            after={<ChangeHistory resource='prompt' recordId={elementId} fieldsSource='resources.prompt.fields' />}
        >
            <Show
                id={elementId}
                resource='prompt'
                actions={false}
                toolbar={false}
                redirect={resource => {
                    handleClose();
                    return resource;
                }}
            >
                <DetailsSampleList>
                    <TextField source='customId' label={translate('resources.prompt.fields.customId')} />
                    <TextField source='name' label={translate('resources.prompt.fields.name')} />
                    <TextField source='model' label={translate('resources.prompt.fields.model')} />
                    <TextField source='content' label={translate('resources.prompt.fields.content')} />
                </DetailsSampleList>
            </Show>
        </RightDrawer>
    );
};

PromptShow.propTypes = {
    handleClose: PropTypes.func.isRequired,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
